import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgInstant = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        d="M17.795 10.25a1.54 1.54 0 0 0-.578-.55c-.24-.134-.515-.2-.79-.2H14V2.624a.62.62 0 0 0-.49-.6c-.284-.076-.595.033-.746.275L6.232 12.25a1.33 1.33 0 0 0-.231.742c-.01.258.062.517.195.75.134.233.338.417.578.558.249.125.524.2.8.2H10v6.877c0 .283.196.525.49.6a.67.67 0 0 0 .747-.275l6.531-9.952c.151-.225.231-.483.231-.742a1.36 1.36 0 0 0-.204-.758m-1.165.842-5.297 8.068v-5.293c0-.342-.302-.625-.666-.625H7.574a.2.2 0 0 1-.125-.033c-.035-.025-.07-.05-.088-.084a.26.26 0 0 1-.036-.116c0-.042.009-.084.036-.117l5.297-8.076v5.292c0 .342.302.625.666.625h3.093c.045 0 .09.009.125.034.035.016.07.05.088.083a.25.25 0 0 1 .027.117.2.2 0 0 1-.026.125"
      />
    </svg>
  );
};
export default SvgInstant;
